import {useState, useMemo} from 'react'
import _ from 'lodash'
import utils from '@eitje/utils'
import {EitjeButton, Placeholder} from '../components'

export const filterItems = (items, query, {searchField = 'name', filterFunc, showSearch = true} = {}) => {
	if (!showSearch || !utils.exists(query)) return items
	if (filterFunc) return filterFunc(items, query)
	return utils.search(items, query, {field: searchField})
}

export const useSearchState = (items, options) => {
	const [search, setSearch] = useState('')

	const filteredItems = useMemo(() => filterItems(items, search, options), [items, search])

	const handleSearch = e => setSearch(e.target.value)
	const handleClear = () => setSearch('')

	return {search, filteredItems, handleSearch, handleClear}
}

export const SearchEmpty = props => {
	const {action = _.noop, ...rest} = props
	if (!Placeholder) return null
	return (
		<Placeholder animation="magnifying-glass" title="common.no_results" subtitle={false} {...rest}>
			{props.action && <EitjeButton onClick={action} iconLeft="trash" t="common.clear_search" />}
		</Placeholder>
	)
}
